import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import { ProfileSectionType } from '../enums/profile-section-type';

const getAllSectionWithDefaultValue = () =>
  Object.values(ProfileSectionType).reduce((sum, current) => ({ ...sum, [current]: [] }), {});

const ValidationRulesRecord = Record({
  ...getAllSectionWithDefaultValue(),
});

export default class ValidationRules extends ValidationRulesRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new ValidationRules(hydrated);
  }
}
